import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    hero: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    eyebrow: {
        letterSpacing: 1,
        color: theme.palette.primary.main,
        marginBottom: 12,
    },
    headline: {
        maxWidth: 720,
        marginBottom: 16,
        lineHeight: 1.1,
        letterSpacing: '-0.025em',
    },
    intro: {
        maxWidth: 640,
        color: theme.palette.text.secondary,
        marginBottom: 24,
    },
    ctaRow: {
        display: 'flex',
        gap: 16,
        marginBottom: 16,
        flexWrap: 'wrap',
    },
    note: {
        display: 'flex',
        gap: 8,
        color: theme.palette.text.secondary,
    },
}));
